/*  MUI  */
import { Grid, Paper, Tab } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { Route } from 'application/Shared/Helpers';
import { Incident } from 'application/Shared/Requests';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { withRouter } from 'router/withRouter';

import AlertConfigurations from './Configurations';
import AlertHistory from './History';

class Alerts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            config: {},
            events: {},
            loaded: false,
            methods: {},
            operands: {},
            resources: {}
        };

        /*  Requests  */
        this.Incident = new Incident();
    }

    componentDidMount() {
        this.loadConfig();
    }

    componentWillUnmount() {
        this.Incident.cancel();
    }

    loadConfig = async () => {
        const data = await this.Incident.getConfig();
        if (!data) {
            return;
        }
        const { events, defaults, config, methods, operands, resources } = data;
        this.setState({
            config,
            defaults,
            events,
            loaded: true,
            methods,
            operands,
            resources
        });
    };

    renderTabs = () => {
        const { match, t } = this.props;
        const { clientId, partnerId, tab } = match.params;
        const activeTab = tab ?? 'history';

        const route = clientId
            ? Route.buildBaseAdminRoute({ clientId, partnerId })
            : Route.buildBasePartnerRoute({ partnerId });

        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <MUITabsWrapper value={activeTab}>
                        <Tab
                            component={Link}
                            to={`${route}/alerts/history`}
                            value="history"
                            label={t('Alerts.tab_history')}
                            aria-label={t('Alerts.tab_history')}
                        />
                        <Tab
                            component={Link}
                            to={`${route}/alerts/configurations`}
                            value="configurations"
                            label={t('Alerts.tab_configurations')}
                            aria-label={t('Alerts.tab_configurations')}
                        />
                    </MUITabsWrapper>
                </Grid>
            </Grid>
        );
    };

    renderPage() {
        const { match, partner } = this.props;
        const { config, defaults, events, methods, operands, resources } =
            this.state;

        const { tab } = match.params;
        const activeTab = tab ?? 'history';

        return (
            <>
                {this.renderTabs()}
                <Paper elevation={0} variant="outlined">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            {activeTab === 'configurations' && (
                                <AlertConfigurations
                                    events={events}
                                    defaults={defaults}
                                    config={config}
                                    methods={methods}
                                    operands={operands}
                                    partner={partner}
                                />
                            )}
                            {activeTab === 'history' && (
                                <AlertHistory
                                    events={events}
                                    defaults={defaults}
                                    config={config}
                                    methods={methods}
                                    operands={operands}
                                    resources={resources}
                                    partner={partner}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            </>
        );
    }

    render() {
        const { t } = this.props;
        const { loaded } = this.state;

        return (
            <>
                <PageTitle title={t('Common.alerting')} />
                {loaded && this.renderPage()}
            </>
        );
    }
}

export default withRouter(withTranslation()(Alerts));
